import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IVehicleList } from "../../../Pages/Vehicle/Ivehicle";

interface IUpdate extends IReduxState<IVehicleList> {
  updateableDate?: IVehicleList;
}

export const UpdateVehicleSlicer = createSlice({
  name: "UpdateVehicle",
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateVehicle: (state, _) => {
      state.isLoading = true;
    },
    successUpdateVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    VehiclesUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateVehicleState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateVehicle,
  failureUpdateVehicle,
  successUpdateVehicle,
  VehiclesUpdateableData,
  clearUpdateVehicleState,
  clearUpdateableData,
} = UpdateVehicleSlicer.actions;

export default UpdateVehicleSlicer.reducer;
